export default __webpack_public_path__ + "static/strategy-consulting-49d499b20ca52fb816ca1ad7aeca896a.webp";